import React from "react";

/**
 * TradeIQ Icon — A brain-circuit with embedded lightning bolt.
 * Combines intelligence (neural network/circuit nodes) with trades (the bolt).
 * Designed to be visually distinct from the SkilledShark branding.
 */
const TradeIQIcon = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Brain outline — left hemisphere */}
    <path d="M7 10c-1.5 0-3-.8-3-2.5S5.5 5 7 5c0-1.7 1.3-3 3-3 1.2 0 2.2.7 2.7 1.7" />
    <path d="M7 10c-1.5 0-3 .8-3 2.5S5.5 15 7 15" />
    {/* Brain outline — right hemisphere */}
    <path d="M17 10c1.5 0 3-.8 3-2.5S18.5 5 17 5c0-1.7-1.3-3-3-3-1.2 0-2.2.7-2.7 1.7" />
    <path d="M17 10c1.5 0 3 .8 3 2.5S18.5 15 17 15" />
    {/* Circuit nodes */}
    <circle cx="9" cy="9" r="1" fill="currentColor" strokeWidth="0" />
    <circle cx="15" cy="9" r="1" fill="currentColor" strokeWidth="0" />
    <circle cx="12" cy="6" r="1" fill="currentColor" strokeWidth="0" />
    {/* Circuit connections */}
    <path d="M9 9h6" strokeWidth="1.2" opacity="0.6" />
    <path d="M12 6v3" strokeWidth="1.2" opacity="0.6" />
    {/* Lightning bolt — the trade symbol */}
    <path d="M13 13l-2 4h3l-2 5 5-6h-3.5L15 13h-2z" fill="currentColor" strokeWidth="0.8" />
  </svg>
);

export default TradeIQIcon;
